import { createContext } from "react";

const ContactFormContext = createContext();

export default ContactFormContext;
